<div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
  <app-admin-products-list-filter
    [filters]="filters"
    (applyFilters)="applyFilters()"
    (productTitleFocus)="onProductTitleFocus()"
    [showProductTitleDropdown]="showProductTitleDropdown"
    [productTitleLoading]="productTitleLoading"
    [productTitleResults]="productTitleResults"
    [mfgCompanies]="mfgCompanies()"
    [categories]="categories()"
    [subCategories]="subCategories()"
    (onProductTitleChange)="onProductTitleChange($event)"
    (selectProductTitle)="selectProductTitle($event)"
    (onCategoryChange)="onCategoryChange($event)"
    (toggleSortOrder)="toggleSortOrder()"
    (hasSubProductsChange)="onHasSubProductsChange($event)"
    (resetFilters)="resetFilters()" />

  @if (loading() && !errorGettingProducts()) {
    <app-loading />
  } @else if (errorGettingProducts()) {
    <app-error-data [title]="errorGettingProducts()!" />
  } @else {
    <div class="flex flex-col gap-4 py-4">
      <div class="flex items-center justify-end">
        <div class="flex rounded-lg border border-gray-200 bg-white p-1 shadow-sm">
          <button
            (click)="viewMode.set('table')"
            [class.bg-danger-bg]="viewMode() === 'table'"
            [class.text-primary]="viewMode() === 'table'"
            class="flex cursor-pointer items-center gap-2 rounded-md px-3 py-1.5 text-[11px] font-bold transition-all">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
            <span i18n="@@productsListOption">List</span>
          </button>
          <button
            (click)="viewMode.set('cards')"
            [class.bg-danger-bg]="viewMode() === 'cards'"
            [class.text-primary]="viewMode() === 'cards'"
            class="flex cursor-pointer items-center gap-2 rounded-md px-3 py-1.5 text-[11px] font-bold transition-all">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
            </svg>
            <span i18n="@@productsCardOption">Cards</span>
          </button>
        </div>
      </div>

      @if (viewMode() === "cards") {
        <app-admin-card-view
          [isFilterApplied]="isFilterApplied()"
          [hasSubproducts]="hasSubproducts()"
          [paginatedProducts]="paginatedProducts()"
          [activeDropdownId]="activeDropdownId()"
          [productImages]="productImages"
          (toggleDropdown)="toggleDropdown($event)"
          (openDeleteDialoug)="onDeleteSuccess($event)"
          (onViewProduct)="onViewProduct($event)"
          (onEditProduct)="onEditProduct($event)" />
      } @else {
        <app-admin-list-view
          [isFilterApplied]="isFilterApplied()"
          [hasSubproducts]="hasSubproducts()"
          [paginatedProducts]="paginatedProducts()"
          (openDeleteDialoug)="onDeleteSuccess($event)" />
      }

      @if (showNotificationFlag) {
        <app-successful-notification
          type="success"
          [title]="isArabic() ? 'تم حذف الصنف بنجاح.' : 'Product deleted successfully.'" />
      }
    </div>
  }
</div>

@if (!loading() && !errorGettingProducts()) {
  <app-pagination
    [itemsPerPage]="pageSize()"
    [currentPage]="currentPage"
    [getPageNumbers]="pageNumbers"
    [totalPages]="totalPages"
    [startItem]="startItem"
    [endItem]="endItem"
    [totalItems]="totalItems()"
    (previousPage)="previousPage()"
    (nextPage)="nextPage()"
    (goToPage)="goToPage($event)"
    (changePageNumber)="onPageSizeChange(+$event)" />
}

@if (unAuthorized()) {
  <app-confirmation-dialog
    [title]="isArabic() ? 'انتهت صلاحية تسجيل الدخول' : 'login expired'"
    [description]="isArabic() ? 'يرجى تسجيل الدخول مرة أخرى!' : 'please login again!'"
    [confirmContent]="isArabic() ? 'سجل الدخول' : 'login'"
    (onSubmit)="redirectToLogin()">
    <svg dialog-icon xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" class="primaryColor">
      <g fill="none">
        <path
          d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
        <path
          fill="currentColor"
          d="M12 2a6 6 0 0 1 5.996 5.775L18 8h1a2 2 0 0 1 1.995 1.85L21 10v10a2 2 0 0 1-1.85 1.995L19 22H5a2 2 0 0 1-1.995-1.85L3 20V10a2 2 0 0 1 1.85-1.995L5 8h1a6 6 0 0 1 6-6m7 8H5v10h14zm-7 2a2 2 0 0 1 1.134 3.647l-.134.085V17a1 1 0 0 1-1.993.117L11 17v-1.268A2 2 0 0 1 12 12m0-8a4 4 0 0 0-4 4h8a4 4 0 0 0-4-4" />
      </g>
    </svg>
  </app-confirmation-dialog>
}
